// FARREN — Variant Gallery Filter v6
// product-media-container + slideshow-slide birlikte filtreler

(function() {
  'use strict';

  function n(s){return!s?'':s.toString().trim().toLowerCase().replace(/ı/g,'i').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ş/g,'s').replace(/ö/g,'o').replace(/ç/g,'c');}

  function getColorInputs() {
    const inputs = [];
    document.querySelectorAll('variant-picker fieldset').forEach(fs => {
      const legend = fs.querySelector('legend');
      const name = legend ? n(legend.textContent) : '';
      if (name.includes('renk') || name.includes('color')) {
        fs.querySelectorAll('input[type="radio"]').forEach(i => inputs.push(i));
      }
    });
    return inputs;
  }

  function getAllColors() { return getColorInputs().map(i => n(i.value)).filter(v => v); }
  function getSelected() { const i = getColorInputs().find(x => x.checked); return i ? n(i.value) : null; }

  function altMatches(altRaw, color) {
    if (!altRaw || !color) return false;
    const alt = n(altRaw);
    return alt.startsWith(color + ' -') || alt.includes(' - ' + color + ' -') || alt.endsWith(' - ' + color);
  }

  function altHasAnyKnown(altRaw, allColors) {
    return allColors.some(c => altMatches(altRaw, c));
  }

  function filterElements(elements, sel, allColors) {
    let visible = 0;
    elements.forEach(el => {
      const img = el.querySelector('img');
      if (!img) { el.style.display = ''; return; }
      const alt = img.alt || '';
      const known = altHasAnyKnown(alt, allColors);
      const matches = altMatches(alt, sel);
      if (known && !matches) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
        visible++;
      }
    });
    return visible;
  }

  function filterGallery() {
    const sel = getSelected();
    const allColors = getAllColors();
    if (!sel || allColors.length < 2) return;

    // Hem slideshow-slide hem product-media-container filtrele
    const slides = document.querySelectorAll('media-gallery slideshow-slide');
    const containers = document.querySelectorAll('media-gallery .product-media-container');

    if (!slides.length && !containers.length) return;

    const visSlides = filterElements(slides, sel, allColors);
    const visContainers = filterElements(containers, sel, allColors);

    // İlk görünür slide'a kay (slideshow varsa)
    const firstVisible = Array.from(slides).find(s => s.style.display !== 'none');
    if (firstVisible) {
      const ss = document.querySelector('media-gallery slideshow-component, media-gallery slideshow-container');
      if (ss && typeof ss.select === 'function') {
        try {
          const idx = Array.from(firstVisible.parentNode.children).indexOf(firstVisible);
          if (idx >= 0) ss.select(idx);
        } catch(e) {}
      }
    }

    if (window.console) console.log('[Farren v6]', sel, '| slides:', visSlides + '/' + slides.length, '| containers:', visContainers + '/' + containers.length);
  }

  window.farrenFilter = filterGallery;

  function bind() {
    getColorInputs().forEach(i => {
      if (i.dataset.fb) return;
      i.dataset.fb = '1';
      i.addEventListener('change', () => { setTimeout(filterGallery, 50); setTimeout(filterGallery, 300); });
    });
    document.querySelectorAll('variant-picker label').forEach(l => {
      if (l.dataset.fb) return;
      l.dataset.fb = '1';
      l.addEventListener('click', () => { setTimeout(filterGallery, 100); setTimeout(filterGallery, 400); });
    });
  }

  function tryStart() {
    const inputs = getColorInputs();
    const containers = document.querySelectorAll('media-gallery .product-media-container');
    if (inputs.length && containers.length) {
      bind();
      filterGallery();
      [200, 600, 1200, 2500].forEach(t => setTimeout(filterGallery, t));
      return true;
    }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryStart);
  }
  window.addEventListener('load', tryStart);
  tryStart();

  let tries = 0;
  const interval = setInterval(() => {
    tries++;
    if (tryStart() || tries > 25) clearInterval(interval);
  }, 200);

  const obs = new MutationObserver(() => {
    bind();
    if (document.querySelectorAll('media-gallery .product-media-container').length > 0) {
      filterGallery();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-fb]').forEach(el => delete el.dataset.fb);
    setTimeout(tryStart, 100);
  });

  ['variant:change','VariantSelected','variantChange','variant-change'].forEach(ev => {
    document.addEventListener(ev, () => setTimeout(filterGallery, 100));
  });

})();
